import { AssetSchema } from 'cms/schemaTypes/generalSchemas/assets'

import { urlFor } from 'lib/sanity/image'

import { BannerImage, SectionContainer } from './styles'

import styles from './LandingsBanner.module.scss'

interface LandingsBannerProps {
  banner: {
    desktop: AssetSchema
    mobile: AssetSchema
  }
}

const LandingsBanner = ({ banner }: LandingsBannerProps) => {
  return (
    <SectionContainer as='div'>
      <div className={styles.onlyDesktopContent}>
        <BannerImage
          src={urlFor(banner.desktop.asset.asset).url()}
          alt={banner.desktop.alt}
          width={1920}
          height={530}
          quality={90}
        />
      </div>
      <div className={styles.tabletContent}>
        <BannerImage
          src={urlFor(banner.mobile.asset.asset).url()}
          alt={banner.mobile.alt}
          width={1080}
          height={540}
          quality={100}
        />
      </div>
    </SectionContainer>
  )
}

export default LandingsBanner
